export default __webpack_public_path__ + "static/media/WBNBcoin.f574e81c.png";